module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/portfolio-item-2-427d9cabb2441173531e35885d236d44.jpg";